<template>
	<div class="main">
		<div class="item" v-for="item in leaderList" :key="item.id">
			<div class="left"><el-image class="headImg" :src="baseImgUrl + item.head"></el-image></div>
			<div class="right">
				<div class="name">{{item.nameEn}}</div>
				<div class="tit">{{item.titEn}}</div>
				<div class="intro">{{item.introEn}}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Leader",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			leaderList: []
		}
	},
	mounted() {
		this.$api.get('about/getLeaders').then(res => {
			this.leaderList = res;
		});
	}
}
</script>

<style scoped>
	.left{ animation: fadeInLeft; animation-duration: 1s; }
	.right{ animation: fadeInRight; animation-duration: 1s; }
	@media (max-width: 1499px){
		.main{ padding: 30px 0 0 0; }
		.item{ display: flex; flex-wrap: nowrap; margin-bottom: 60px; }
		.left{ width: 180px; height: 180px; padding-top: 10px; }
		.right{ width: 100%; height: fit-content; margin-left: 20px;
			border-top: 1px solid #ffffff;
			border-bottom: 1px solid #afafaf;
			border-right: 4px solid #196486;
			border-top-right-radius: 12px;
			border-bottom-right-radius: 12px;
			padding: 10px;
		}
		.headImg{ width: 180px; height: 180px; border-radius: 50%; }
		.name{ font-size: 22px; font-weight: bold; }
		.tit{ width: 80%; font-size: 18px; border-bottom: 3px solid #e76711; margin-top: 10px; }
		.intro{ font-size: 16px; margin-top: 10px; }
	}
	@media (min-width: 1500px){
		.main{ padding: 30px 0 0 0; }
		.item{ display: flex; flex-wrap: nowrap; margin-bottom: 60px; }
		.left{ width: 220px; height: 220px; padding-top: 10px; }
		.right{ width: 100%; height: fit-content; min-height: 220px; margin-left: 20px;
			border-top: 1px solid #ffffff;
			border-bottom: 1px solid #afafaf;
			border-right: 4px solid #196486;
			border-top-right-radius: 12px;
			border-bottom-right-radius: 12px;
			padding: 10px;
		}
		.headImg{ width: 220px; height: 220px; border-radius: 50%; }
		.name{ font-size: 22px; font-weight: bold; }
		.tit{ width: 300px; font-size: 18px; border-bottom: 3px solid #e76711; margin-top: 10px; }
		.intro{ font-size: 16px; margin-top: 10px; }
	}

</style>